import styled from "styled-components";

export const ModalInner = styled.div`
  width: 80vw;
  max-width: 747px;
  height: 80vh;
  position: relative;
  overflow-y: auto;
`;
